import React, {useEffect, useState} from 'react';
import NavBar from '../../../uiToolkit/NavBar';
import {Col, Container, Row} from 'react-bootstrap';
import {SubscriptionCancelText} from './SubscriptionCancelText';
import Button from '../../../uiToolkit/Buttons/Button';
import styles from './SubscriptionCancel.module.css';
import {useNavigate, useParams} from 'react-router-dom';
import NavigationStore from '../../../navigation/store/NavigationStore';
import {inject, observer} from 'mobx-react';
import {ReactComponent as CrossIcon} from '../../../assets/images/close_filter_ic.svg';

interface Props {
  navigationStore?: NavigationStore;
}

const SubscriptionCancel = inject('navigationStore')(
  observer(({navigationStore}: Props) => {
    const {organizationId} = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      refreshWorkspaceData();
    }, []);

    const refreshWorkspaceData = async () => {
      if (organizationId) {
        await navigationStore!.refreshToken();
        await navigationStore!.tryGetMyOrganization();
        await navigationStore!.getOrganizationDetails(organizationId);
        await navigationStore!.getOrganizationDashboardAnalytics(
          organizationId,
        );
        setIsLoading(false);
      }
    };

    const onGoToWorkspace = () => {
      navigate(`/manage/${organizationId}/workspace`);
    };
    const onGoToPlans = () => {
      navigate(`/manage/${organizationId}/settings/subscription`);
    };

    return (
      <div>
        <NavBar />
        <Container>
          <Row>
            <Col xs={12}>
              <div className={styles.container}>
                <CrossIcon className={styles.cancelIcon} />
                <h1>{SubscriptionCancelText.title}</h1>
                <h4>{SubscriptionCancelText.subtitle1}</h4>
                <h4>{SubscriptionCancelText.subtitle2}</h4>
                <div className={styles.infoBox}>
                  <h4>{SubscriptionCancelText.whatsNext}</h4>
                  <p>{SubscriptionCancelText.cardText}</p>
                  <Button
                    title={SubscriptionCancelText.goToWorkspace}
                    onClick={onGoToWorkspace}
                    className={styles.button}
                    isLoading={isLoading}
                  />
                  <Button
                    title={SubscriptionCancelText.goToSubscrioptions}
                    onClick={onGoToPlans}
                    className={styles.button}
                    isLoading={isLoading}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }),
);

export default SubscriptionCancel;
